import React from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'
import { Icon, MenuItem, Spinner } from '@blueprintjs/core'

import {
    getCustomerResults,
    searchCustomer,
} from 'src/store/modules/cmdb/customers'
import InputSelect from './InputSelect'

const customerRenderer = (customer, { handleClick, modifiers }) => {
    return (
        <MenuItem
            active={modifiers.active}
            key={customer.id}
            text={customer.name}
            onClick={handleClick}
        />
    )
}

class CustomerSelect extends React.Component {
    renderInputValue = (customer) => customer.name

    componentDidMount() {
        setTimeout(() => {
            if (this.solutionInput) this.solutionInput.focus()
        }, 300)
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            setTimeout(() => {
                if (this.solutionInput) this.solutionInput.focus()
            }, 300)
        }
    }

    solutionInputRef = (ref) => (this.solutionInput = ref)

    render() {
        const {
            selected,
            customers,
            loading,
            searchCustomer,
            onCustomerSelect,
        } = this.props
        return (
            <InputSelect
                inputProps={{
                    placeholder: 'Organization',
                    large: true,
                    inputRef: this.solutionInputRef,
                    rightElement: loading ? (
                        <Spinner size={Icon.SIZE_STANDARD} />
                    ) : null,
                }}
                itemRenderer={customerRenderer}
                noResults={<MenuItem disabled text="No results" />}
                items={customers}
                inputValueRenderer={this.renderInputValue}
                onQueryChange={(value) => searchCustomer(value)}
                popoverProps={{ minimal: true }}
                onItemSelect={(customer) => onCustomerSelect(customer)}
                selectedItem={selected}
            />
        )
    }
}

CustomerSelect.propTypes = {
    onCustomerSelect: propTypes.func.isRequired,
    selected: propTypes.shape({
        name: propTypes.string.isRequired,
        id: propTypes.number.isRequired,
    }),
}

export default connect(
    (state) => ({
        customers: getCustomerResults(state),
        loading: state.cmdb.customers.loading,
    }),
    { searchCustomer }
)(CustomerSelect)
